import { forwardRef } from "react";

import type { ReactNode } from "react";

export interface NotebookViewMainBodyProps {
  children?: ReactNode;
}

export const NotebookViewMainBody = forwardRef<
  HTMLDivElement,
  NotebookViewMainBodyProps
>(function NotebookViewMainBody({ children }, ref) {
  return (
    <div className="NotebookViewMainBody" ref={ref}>
      {children}
    </div>
  );
});
